import React from 'react';
import ReactDOM from 'react-dom';
import onClickOutside from 'react-onclickoutside';
import PropTypes from 'prop-types';
import _noop from 'lodash/noop';

class Portal extends React.Component {
  constructor(props) {
    super(props);
    this.portalElem = document.createElement('div');
    this.portalElem['data-test'] = 'portal';
  }

  componentDidMount() {
    document.body.appendChild(this.portalElem);
    document.addEventListener('keydown', this.handleKeyDown, true);
  }

  componentWillUnmount() {
    document.body.removeChild(this.portalElem);
    document.removeEventListener('keydown', this.handleKeyDown, true);
  }

  handleKeyDown = e => {
    e.stopPropagation();

    if (e.key === 'Escape') {
      this.props.onEscapeClick();
    }
  };

  handleClickOutside = () => {
    this.props.onOutsideClick();
  };

  render() {
    return ReactDOM.createPortal(this.props.children, this.portalElem);
  }
}

Portal.propTypes = {
  children: PropTypes.element.isRequired,
  onOutsideClick: PropTypes.func,
  onEscapeClick: PropTypes.func,
};

Portal.defaultProps = {
  onOutsideClick: _noop,
  onEscapeClick: _noop,
};

export default onClickOutside(Portal);
